import { useQuery } from '@tanstack/react-query';

import { courseConst, ICourse } from 'modules/courses';
import { $apiV2 } from 'modules/global';

export const getRecommendedCourses = (ticketId?: number) => async () => {
  const { data } = await $apiV2.get(`/teacher-course/recommended-courses`, { params: { ticket_id: ticketId } });

  return { recommendedCourses: data?.data };
};

export const useRecommendedCourses = (ticketId?: number) => {
  const { data, ...args } = useQuery<{ recommendedCourses: ICourse[] }>({
    queryKey: [courseConst.queryKeys.RECOMMENDED_COURSES, ticketId],
    queryFn: getRecommendedCourses(ticketId)
  });

  return { ...data, ...args };
};
